import { useQuery } from "@tanstack/react-query";
import api from "../../../api";
import type { components } from "../../../types/api.types";
import urls from "../../../urls";

export type MeteringConceptResponse =
  components["schemas"]["MeteringConceptResponse"];

/**
 * Fetches the list of available metering concepts (Messkonzepte).
 *
 * @returns A react-query result whose `data` is an array of
 *   {@link MeteringConceptResponse}. Cached indefinitely since the list is
 *   effectively static.
 */
export function useMeteringConcepts() {
  return useQuery({
    queryKey: ["meteringConcepts"],
    queryFn: fetchMeteringConcepts,
    staleTime: Infinity
  });
}

async function fetchMeteringConcepts() {
  const response = await api.get<Array<MeteringConceptResponse>>(
    urls.api.meteringConcepts()
  );
  return response.data;
}
